__webpack_require__.p = "/al-qurdle/";